import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TrimTextDisplayWithHover from '../generics/TrimTextDisplayWithHover';
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: "#F7FBFF",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        // border: 0,
    },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        fontSize: 13,
        color: "#444444",
        fontWeight: "500",
        borderRight: "1px solid #E8ECF0",
        borderBottom: 0,
        padding: "5px 8px",
        lineHeight:"2.5em"
    },
    [`&.${tableCellClasses.body}:last-child`]: {
        borderRight: 1,
        borderBottom: 0,
    },
    [`&.${tableCellClasses.body}.norecords`]: {
        textAlign: 'center',
        fontSize: '15px',
        color: 'red'
    }
}));

const CommonTableBody = (props) => {
    const { rows,keyField,tableRowStyle, columnDefs, page, rowsPerPage, totalRecords} = props

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - totalRecords) : 0;

    
    return (
        <TableBody>
            {rows.length > 0 && rows.map((row,rowIndex) => (
                row.isTotalRow?
                 <StyledTableRow
                 key={'Total-Row'}
                 style={{ background: "#f6f8fc" }} className="grid"
                 >
                    <StyledTableCell colSpan={row.colSpan} style={{ textAlign: "right", fontWeight: "700" }} key={`fd-${rowIndex}-caption}`} >{row.totalCaption}</StyledTableCell>
                    {columnDefs.map((col, colIndex) => (
                            !col.isHidden && colIndex >= row.colSpan ? ( // Skip the first colSpan columns
                                <StyledTableCell key={`Total-${col.field}`} style={col.sx}>
                                     {row.hasOwnProperty(col.field) ? row[col.field] : ''}
                                </StyledTableCell>
                            ) : null
                        ))}
                 </StyledTableRow>:
                <StyledTableRow
                    key={row[keyField]}
                    style={tableRowStyle}
                >
                    {columnDefs && columnDefs.map((col,colIndex) => (
                        !col.isHidden && <StyledTableCell style={col.sx} key={`fd-${rowIndex}-${col.field}}`} >
                            {   col.cellRender && typeof col.cellRender === 'function' ? (
                                    col.cellRender(row,col,rowIndex)
                                ) : 
                                    ( col.valueFormatter && typeof col.valueFormatter === 'function' ? (
                                        col.valueFormatter(row[col.field],row,col)
                                    ) :  col.trimTextLength && typeof col.trimTextLength === 'number' && row[col.field].length > col.trimTextLength ? (
                                        <TrimTextDisplayWithHover dataString={row[col.field]} dataLength={col.trimTextLength} />
                                    ) : (
                                       <>  { row[col.field] } </>
                                    ) 
                                ) 
                            }
                        </StyledTableCell>
                    ))}
                </StyledTableRow>
            ))}
            {rows.length === 0 && (
                <StyledTableRow key="commonTableNoRecordRow">
                    <StyledTableCell colSpan={columnDefs.length} align="center" className='norecords'>
                        No Records Found
                    </StyledTableCell>
                </StyledTableRow>
            )}
            {emptyRows > 0 && (
                <StyledTableRow style={{ height: 53 * emptyRows }} key="commonTableEmptyRow">
                    <StyledTableCell colSpan={columnDefs.length} />
                </StyledTableRow>
            )}
        </TableBody>
    )
}
export default CommonTableBody;